
function slide3_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var banners = '';
  var cislo = 0;

  slideReset();
  changeBG("bg3");

  var menuTest = $("#menu_top").attr("style");
  console.log(menuTest);

  $('#tmi1').removeClass('active');
  $('#tmi2').removeClass('active');
  $('#tmi3').addClass('active');

  bmcont = '<div id="sl3_head"></div><div id="zalozka"></div><div id="sl3_cnt" class="sl_cnt"></div><div id="info" class="info" style="display:none;">'+jsondata["sl3_txt1"]+'</div><div id="fontana" style="display:none;">'+jsondata["sl3_tlac2"]+'</div><div id="mapaCR" style="display:none;">'+jsondata["sl3_tlac1"]+'</div><div id="sl3_bm1" class="menu_bott_big">';
  pocet = jsondata["sl3_menu1"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id="sl3_big'+i+'" class="bmi_big" data-clicked="'+i+'"><div class="bmi_bg_big"></div><div class="bmi_point_big">';
    bmcont += '<i class="icon icon-5"></i>';
    bmcont += '</div><div id="big'+i+'_tt" class="bmitt_big">'+jsondata["sl3_menu1"][i-1]+'</div></div>';
  }
  bmcont += '</div>';
  bmcont += '<div id="sl3_bm2" class="menuLecba">';
  pocet = jsondata["sl3_menu2"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id=\"menuLecba_'+i+'\" class=\"lecba\" data-clicked="'+i+'"><i class=\"icons icon-7_'+i+'\"></i><p class=\"label\">'+jsondata["sl3_menu2"][i-1]+'</p></div>';
  }
  bmcont += '</div>';

  bmcont += '<div id="page2" class="arrowL"><i class="arrow-left"></i></div><div id="page5" class="arrowR"><i class="arrow-right"></i></div>';

  $("#slide3").html(bmcont);

  $('#slide3').fadeIn(1000);
  $('#info').fadeIn(500);
  $('#fontana').fadeIn(200);
  $('#mapaCR').fadeIn(100);
  bannerReset();
  loadBanners(4,"sl3_banner2");

  coSebou = jsondata["sl34_tlac"];
  $("#zalozka").html(coSebou);

  bannerReset();
  $(".lecba").on("click", function(){
		var id = $(this).attr("id");
    var clickid = $(this).data("clicked");
    $(".lecba .icons").removeClass("active");
    $("#"+id+" .icon-7_"+clickid).addClass("active");

    bannerReset();
    clickBanner(id,4);

    $("#ban_4_"+clickid).fadeIn(100);
    var bannerBox = document.getElementById("ban_4_"+clickid);
    TweenMax.to(bannerBox, 1, {x:0, y:-500,  ease:Quint.easeOut});
    TweenMax.to(bannerBox, 0.5, {autoAlpha:1});

  });

  $("#zalozkaOpen").on("click", function(){
      bannerReset();
  		var bannerBox = document.getElementById("coSebou");
  		TweenMax.to(bannerBox, 1, {x:-570, y:-0,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
  });

  $("#coSebouClosed").on("click", function(){
      bannerReset();
  		var bannerBox = document.getElementById("coSebou");
  		TweenMax.to(bannerBox, 1, {x:0, y:0,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
  });

  $("#circle_pos_3_2").on("click", function(){
    bannerReset();
    slide4_anima();
  });

  $("#page2").on("click", function(){
    bannerReset();
    slide2_anima();
  });

  $("#page5").on("click", function(){
    bannerReset();
    slide5_anima();
  });




}
